import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=e982502c&scoped=true&"
import script from "./EditDocument.vue?vue&type=script&lang=ts&"
export * from "./EditDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e982502c",
  null
  
)

export default component.exports